/*  iceberg-ui  */
import { IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Box, TextField } from '@mui/material';

/* Shared */
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ManagedTableSearchBar = ({
    disabled,
    searchText,
    setPage,
    setSearchText
}) => {
    const { t } = useTranslation();

    const handleSearchChange = async (event) => {
        const val = event ? event.target.value : '';
        const currentSearchText = val.toLowerCase();

        setPage(0);
        setSearchText(currentSearchText);
    };

    return (
        <Box data-testid="managedTableSearchBar">
            <TextField
                autoComplete="off"
                data-trackid="managedTableSearchBarTextField"
                disabled={disabled}
                sx={{ width: '100%' }}
                InputProps={{
                    startAdornment: (
                        <IconWithVariant
                            variant="search"
                            src="Search"
                            size={FontSizes[1]}
                            wrapperProps={{ marginRight: '4px' }}
                        />
                    )
                }}
                // InputProps is for the root div, and inputProps is for the HTML input element.
                // eslint-disable-next-line react/jsx-no-duplicate-props
                inputProps={{
                    'data-trackid': 'managedTableSearchBarInput'
                }}
                onChange={(event) => handleSearchChange(event)}
                placeholder={t('ManagedTable.search')}
                value={searchText}
                variant="outlined"
                size="small"
            />
        </Box>
    );
};
